import { render, staticRenderFns } from "./DoctorSideBarPayment.vue?vue&type=template&id=53979d8c&scoped=true&"
import script from "./DoctorSideBarPayment.vue?vue&type=script&lang=js&"
export * from "./DoctorSideBarPayment.vue?vue&type=script&lang=js&"
import style0 from "./DoctorSideBarPayment.vue?vue&type=style&index=0&id=53979d8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53979d8c",
  null
  
)

export default component.exports